<template>
    <div class="listBook">
      <div class="box">
        <div class="box_title">
          <span class="title">{{ title }}：</span>
          <!-- <span class="text">展开</span> -->
          <template v-if="detail.length>6">
            <span class="text" v-if="!show" @click="show = !show">展开</span>
            <span class="top" v-else @click="show = !show"></span>
          </template>
        </div>
        <div class="box_content">
          <ul class="list" :class="'list'+currentActive">
            <template
              v-for="(item, index) in detail"
            >
              <li
                v-if="index < 6 || show"
                :key="index"
                class="list_item"
                :class="{active:item.id === changeId}"
                @click="change(item)"
              >
                {{ item.name }}
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    active: {
      type: Number,
      default: 0
    },
    popupShow: {
      type: Boolean
    },
    currentActive: {
      type: Number
    }
  },
  watch: {
    popupShow: {
      handler (v) {
        if (v) {
          this.changeId = this.active;
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      changeId: 0,
      show: false
    };
  },
  methods: {
    change (item) {
      this.changeId = item.id;
      this.$emit('itemClick', item.id);
    }
  }
};
</script>

<style scoped lang="less">
  .listBook{
    margin-bottom: 54px;
    &:last-child{
      margin-bottom: 0;
    }
    .box{
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-bottom: 54px;
      &:last-child{
        margin-bottom: 0px;
      }
      .box_title{
        margin-bottom: 40px;
        font-size: 28px;
        font-weight: bold;
        line-height: 36px;
        color: #333444;
        display: flex;
        justify-content: space-between;
        .text{
          font-size: 24px;
          margin-right: 10px;
          line-height: 34px;
          color: #999AAA;
          font-weight: 500;
          display: flex;
          &::after{
            content: "";
            display: block;
            border-right: 0.02667rem solid #333333;
            border-bottom: 0.02667rem solid #333333;
            width: 10px;
            height: 10px;
            transform: rotate(45deg);
            margin-left: 7px;
            margin-top: 3px;
            transform: translate(50% , 0px) rotate(45deg);
          }
        }
        .top{
          &::after{
            content: "";
            display: block;
            border-right: 0.02667rem solid #333333;
            border-bottom: 0.02667rem solid #333333;
            width: 10px;
            height: 10px;
            transform: rotate(45deg);
            margin-left: 7px;
            margin-right: 20px;
            margin-top: 12px;
            transform: translate(50% , 0px) rotate(-135deg);
          }
        }
      }
      .box_content{
        .list{
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          .list_item{
            border-radius: 40px;
            font-size: 24px;
            padding: 14px 8px;
            margin-right: 26px;
            // height: 62px;
            // line-height: 62px;
            text-align: center;
            width: 156px;
            margin-top: 32px;
            background: #F9F9F9;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            &.active{
              color: #5FA9FF;
              border: 2px solid #5FA9FF;
              box-sizing: border-box;
            }
            &:nth-child(3n){
              margin-right: 0;
            }
            &:nth-child(-n+3){
              margin-top: 0px;
            }
          }
          &.list2{
            .list_item{
              &.active{
                color: #FCB645;
                border: 2px solid #FCB645;
                box-sizing: border-box;
              }
            }
          }
        }
      }
    }
  }
</style>
